export default "__VITE_ASSET__7f89ea94__"